import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/form/application_form_source";
import {PROPERTY_FAQ_ASK_DEVELOPER_SOURCE, propertyFaqAnalytics, PropertyFaqQuestionType} from "../../tracking/property_faq_tracking";

interface IProps {
    propertyId: number;
    offerId: number;
    offerName: string;
    vendorId: number;
    vendorName: string;
    questionHeading: string;
    questionIndex: number;
    questionType: PropertyFaqQuestionType;
}

export const PropertyDetailFaqAnswerActions = (props: IProps) => (
    <div className={actionsRowStyle}>
        <div className={primaryActionsStyle}>
            <ApplicationModalButton
                vendorId={props.vendorId}
                offerId={props.offerId}
                propertyId={props.propertyId}
                source={ApplicationSource.Property}
                sourceSection={ApplicationSourceSection.BODY}
                customSourceSection={PROPERTY_FAQ_ASK_DEVELOPER_SOURCE}
                render={({openModal}) => (
                    <Button
                        variant="filled_secondary"
                        size="x-small"
                        type="button"
                        className={primaryActionButtonStyle}
                        onClick={() => {
                            propertyFaqAnalytics.gtm.askDeveloperClick("Więcej informacji");

                            if (props.questionType === "custom") {
                                propertyFaqAnalytics.amplitude.moreInfoClick({
                                    index: props.questionIndex,
                                    itemId: props.offerId,
                                    propertyId: props.propertyId,
                                    questionHeading: props.questionHeading,
                                    questionType: props.questionType
                                });
                            }

                            openModal({
                                clickText: "Więcej informacji",
                                source: "property_detail_faq_ai_answer",
                                vendorName: props.vendorName,
                                offerName: props.offerName
                            });
                        }}
                    >
                        Więcej informacji
                    </Button>
                )}
            />
        </div>
    </div>
);

const actionsRowStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
    width: "100%",
    py: 1,

    md: {
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 2
    }
});

const primaryActionsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    width: "100%",

    md: {
        flexDirection: "row",
        gap: 2,
        width: "auto"
    }
});

const primaryActionButtonStyle = css({
    width: "100%",

    md: {
        width: "auto"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/form/application_form_source";
import {PROPERTY_FAQ_ASK_DEVELOPER_SOURCE, propertyFaqAnalytics, PropertyFaqQuestionType} from "../../tracking/property_faq_tracking";

interface IProps {
    propertyId: number;
    offerId: number;
    offerName: string;
    vendorId: number;
    vendorName: string;
    questionHeading: string;
    questionIndex: number;
    questionType: PropertyFaqQuestionType;
}

export const PropertyDetailFaqAnswerActions = (props: IProps) => (
    <div className={actionsRowStyle}>
        <div className={primaryActionsStyle}>
            <ApplicationModalButton
                vendorId={props.vendorId}
                offerId={props.offerId}
                propertyId={props.propertyId}
                source={ApplicationSource.Property}
                sourceSection={ApplicationSourceSection.BODY}
                customSourceSection={PROPERTY_FAQ_ASK_DEVELOPER_SOURCE}
                render={({openModal}) => (
                    <Button
                        variant="filled_secondary"
                        size="x-small"
                        type="button"
                        className={primaryActionButtonStyle}
                        onClick={() => {
                            propertyFaqAnalytics.gtm.askDeveloperClick("Więcej informacji");

                            if (props.questionType === "custom") {
                                propertyFaqAnalytics.amplitude.moreInfoClick({
                                    index: props.questionIndex,
                                    itemId: props.offerId,
                                    propertyId: props.propertyId,
                                    questionHeading: props.questionHeading,
                                    questionType: props.questionType
                                });
                            }

                            openModal({
                                clickText: "Więcej informacji",
                                source: "property_detail_faq_ai_answer",
                                vendorName: props.vendorName,
                                offerName: props.offerName
                            });
                        }}
                    >
                        Więcej informacji
                    </Button>
                )}
            />
        </div>
    </div>
);

const actionsRowStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
    width: "100%",
    py: 1,

    md: {
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 2
    }
});

const primaryActionsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    width: "100%",

    md: {
        flexDirection: "row",
        gap: 2,
        width: "auto"
    }
});

const primaryActionButtonStyle = css({
    width: "100%",

    md: {
        width: "auto"
    }
});
